"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomSectionWrapper = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
const CustomSectionWrapper = (0, _styled.default)("div")`
    display: flex;
    flex-wrap: wrap;
`;
exports.CustomSectionWrapper = CustomSectionWrapper;
//# sourceMappingURL=CustomSectionWrapper.js.map